import { motion } from "framer-motion";
import { useInView } from "@/hooks/useInView";
import { useState, useEffect } from "react";

interface FadeInSectionProps {
  children: React.ReactNode;
  triggerOnce?: boolean;
}

const FadeInSection: React.FC<FadeInSectionProps> = ({
  children,
  triggerOnce = true,
}) => {
  const { ref, inView } = useInView(0.2);
  const [hasBeenInView, setHasBeenInView] = useState(false);

  useEffect(() => {
    if (inView && triggerOnce) {
      setHasBeenInView(true);
    }
  }, [inView, triggerOnce]);

  const shouldAnimate = triggerOnce ? hasBeenInView : inView;

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={shouldAnimate ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.6 }}
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default FadeInSection;
